import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["pageInput"];

  connect() {
    this.lastValidPage = this.pageInputTarget.value;
  }

  handleSubmit() {
    // the submit event is triggered when the user types "enter", but we want to handle
    // submit ourselves in our change handlers below, so we eat the submit event.  The
    // only exception is when there is no change, so the change handlers don't get fired,
    // and the UI sits there as if you never typed enter.  So we take the focus off of
    // the focused input, so the user sees that the enter key was noted, even if no
    // actual change occurred.

    const pageInput = this.pageInputTarget;

    if (pageInput.value == this.lastValidPage)
      pageInput.blur();

    event.preventDefault();
  }

  // monitor input events to make sure that the text in this input
  // is always viable for a non-negative integer

  handlePageInput() {
    const input = this.pageInputTarget;

    if (/\D/.test(input))  // basically if there's a non-numeric character present in the input
      input.value = input.value.replace(/\D/g, ""); // remove it from the input
  }

  handlePageChange() {
    const input = this.pageInputTarget;

    if (/^0*$/.test(input.value))  // make sure the input isn't 0 or the empty string
      input.value = this.lastValidPage;
    else
      this.element.submit();  // note that this submits the form, but doesn't generate a submit event
  }

  handlePerPageChange() {
    this.element.submit();  // note that this submits the form, but doesn't generate a submit event
  }

}